<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 14 15" fill="none" :class="color">
        <path d="M9 7.33301C10.6667 7.33301 12 8.66634 12 10.333C12 10.933 11.7998 11.466 11.5332 11.9326L13.334 13.7334L12.4004 14.666L10.6006 12.8662C10.1339 13.1329 9.6 13.333 9 13.333C7.33349 13.3328 6 11.9996 6 10.333C6 8.66645 7.33349 7.33318 9 7.33301ZM6 0C6.86661 0 7.59984 0.559748 7.87988 1.33301H10.667C11.4002 1.33301 11.9998 1.93283 12 2.66602V6H10.667V2.66602H9.33398V4.66602H2.66699V2.66602H1.33398V12H4.66699V13.333H1.33398C0.60076 13.333 0.000177829 12.7332 0 12V2.66602C0.000177439 1.93283 0.600759 1.33301 1.33398 1.33301H4.12012C4.40008 0.559771 5.13348 0.00014027 6 0ZM9 8.66602C8.06682 8.66619 7.33398 9.39978 7.33398 10.333C7.33398 11.2662 8.06682 11.9998 9 12C9.93333 12 10.667 11.2663 10.667 10.333C10.667 9.39967 9.93333 8.66602 9 8.66602ZM6 1.33301C5.63348 1.33319 5.33398 1.63344 5.33398 2C5.33416 2.36641 5.63359 2.66584 6 2.66602C6.36656 2.66602 6.66681 2.36652 6.66699 2C6.66699 1.63333 6.36667 1.33301 6 1.33301Z" fill="#171717"/>
    </svg>
</template>

<script>
    export default {
        name: 'preview-icon',
        props: {
            width: {
                type: [String, Number],
                default: 14,
            },
            height: {
                type: [String, Number],
                default: 15,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
